import lodash from "lodash";
import moment from "moment";
import {
    createColumnDate,
    createColumnDatetime,
    createColumnInput,
    createColumnInputNumber,
    createColumnSelect,
    createColumnTreeSelect
} from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import { putField } from "../../../../utils/form";
import { callDepartment, callUserObjective } from "../../../account/register/register.section";
import { callRequestDoc } from "../../storage-location/request/request.section";

export const createColumns = () => {
    const columns = [
        createColumnSelect({
            title: () => i18n.global.t("views.report.docType"),
            dataIndex: "refRequestDoc.value",
            inputProp: () => ({ list: callRequestDoc, optLabel: "value" }),
            search: { name: "refRequestDoc.id" },
            align: "center"
        }),
        createColumnInput({ title: () => i18n.global.t("views.report.approveCode"), dataIndex: "approveCode", align: "center" }),
        createColumnDate({ title: () => i18n.global.t("views.report.docCreateDate"), dataIndex: "docCreateDate", align: "center" }),
        createColumnDate({ title: () => i18n.global.t("views.report.docExpireDate"), dataIndex: "docExpireDate", align: "center" }),
        createColumnSelect({
            title: () => i18n.global.t("views.report.operationType"),
            dataIndex: "refOperation.value",
            inputProp: () => ({ list: callUserObjective, optLabel: "value" }),
            search: { name: "refOperation.id" },
            align: "center"
        }),
        createColumnDatetime({ title: () => i18n.global.t("views.report.startDatetime"), dataIndex: "startDatetime", align: "center" }),
        createColumnDatetime({ title: () => i18n.global.t("views.report.endDatetime"), dataIndex: "endDatetime", align: "center" }),
        createColumnInput({
            title: () => i18n.global.t("views.report.docDuration"),
            dataIndexValue: ({ record }) => {
                const ms = moment(record.endDatetime).diff(moment(record.startDatetime));
                const d = moment.duration(ms);
                const s = lodash.padStart(Math.floor(d.asHours()), 2, "0") + moment.utc(ms).format(":mm:ss");
                return s;
            },
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "center",
            search: { visible: () => false }
        }),
        createColumnTreeSelect({
            title: () => i18n.global.t("model.request.refDepartment"),
            dataIndex: "refDepartment.nameTh",
            inputProp: () => ({
                list: callDepartment,
                renderLabel: ({ item }) => (
                    <div>
                        {item.fullCode} : {item.nameTh}
                    </div>
                ),
                filterWhere: ({ value }) => [
                    { name: "fullCode", operator: "like", value },
                    { logic: "OR", name: "nameTh", operator: "like", value }
                ],
                treeDefaultExpandAll: true
            }),
            search: { name: "refDepartment.id" },
            width: 200
        }),
        createColumnInputNumber({ title: () => i18n.global.t("views.report.editCount"), dataIndex: "editCount", align: "center" }),
    ];
    return columns;
};

export const createField = ({ data }) => {
    return putField({
        data,
        fields: []
    });
};
